<script setup>
import Modal from '@/components/Shared/Modal.vue';
import FormInput from '@/components/Shared/Form/Input/Index.vue';
import { useForm } from '@inertiajs/vue3';
import FormButton from '@/components/Shared/Form/Button.vue';
import Swal from 'sweetalert2';
import { inject } from 'vue';

const trans = inject('trans');

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  partner: {
    type: Object,
    required: true,
  },
  applications: {
    type: Object,
    required: true,
  },
  leadTypes: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['close']);

const form = useForm({
  type: null,
  application_1: null,
  application_2: null,
  subject: null,
  message: null,
  partner_id: props.partner.id,
});

const submit = () => {
  form
    .transform(data => ({
      ...data,
      type: data.type?.id,
    }))
    .post(route('dashboard.partner.leads.store'), {
      preserveScroll: true,
      onSuccess: () => {
        form.reset();

        emit('close');

        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: trans('__JSON__.Your request has been sent to the partner.'),
        });
      },
    });
};
</script>

<template>
  <modal :show="show" @close="$emit('close')">
    <template #title>
      <h2 class="text-90 font_bold text-xl uppercase">{{ trans('__JSON__.Submit Request') }}</h2>
      <h2 class="text-90 font-normal text-xl">{{ partner.companyName }}</h2>
    </template>

    <template #content>
      <form class="my-4 w-full" @submit.prevent="submit" role="form">
        <div class="grid grid-4 gap">
          <form-input
            id="type-question"
            container-class="row-span-2"
            type="select"
            v-model="form.type"
            :options="leadTypes"
            track-by="id"
            label="name"
            :label-text="trans('__JSON__.Type of question')"
            :error="form.errors.type"
            :placeholder="trans('__JSON__.Select type of question')"
          />
          <form-input
            id="application-1"
            type="select"
            v-model="form.application_1"
            track-by="id"
            label="name"
            :options="applications"
            :label-text="trans('common.application') + ' 1'"
            :error="form.errors['application_1.id']"
            :placeholder="trans('__JSON__.Select application') + ' 1'"
          />
          <form-input
            id="application-2"
            type="select"
            v-model="form.application_2"
            track-by="id"
            label="name"
            :options="applications"
            :label-text="trans('common.application') + ' 2'"
            :error="form.errors['application_2.id']"
            :placeholder="trans('__JSON__.Select application') + ' 2'"
          />
        </div>
        <div>
          <form-input
            id="subject"
            container-class="w-2/3 my-4"
            type="text"
            v-model="form.subject"
            :label-text="trans('__JSON__.Subject')"
            :error="form.errors.subject"
          />

          <form-input
            id="message"
            container-class="w-full my-4"
            type="textarea"
            v-model="form.message"
            :label-text="trans('__JSON__.Comment/Question')"
            :error="form.errors.message"
          />
        </div>
        <div class="flex justify-content-end">
          <form-button :value="trans('__JSON__.Send')" :processing="form.processing" />
        </div>
      </form>
    </template>
  </modal>
</template>

<style scoped>
.row-span-2 {
  grid-column: span 2;
}
</style>
